import { createFileRoute, redirect } from '@tanstack/react-router';

export const Route = createFileRoute('/locations/new')({
  validateSearch: (search: Record<string, unknown>) => ({
    locationGroupId:
      typeof search.locationGroupId === 'string' ? search.locationGroupId : undefined,
  }),
  beforeLoad: ({ search }) => {
    if (search.locationGroupId) {
      throw redirect({
        to: '/warehouses/$locationGroupId/new',
        params: { locationGroupId: search.locationGroupId },
        replace: true,
      });
    }
    throw redirect({ to: '/warehouses', replace: true });
  },
});
